


























import Vue, { PropType } from "vue";
import CPMTransitionChart from "@/features/home/components/cpmTransitionChart.vue";
import NoData from "@/features/home/components/noData.vue";
import { CPMTransition } from "@/features/home/types";

export default Vue.extend({
  components: {
    "cpm-transition-chart": CPMTransitionChart,
    "no-data": NoData,
  },
  props: {
    loading: { type: Boolean, required: true },
    isNoData: { type: Boolean, required: true },
    hasMissingData: { type: Boolean, required: true },
    chartData: { type: Object as PropType<CPMTransition> },
    chartHeight: { type: Number, default: 250 },
  },
});
